import React, { useState, useRef, useCallback, useEffect } from "react";
import { Grid, message, Row, Col, Button } from "antd";
import Capture from "./capture";
import Validate from "./validate";
import "antd/dist/antd.css";
import Logo from './../acsset/logo.png';
import Helper from './../../extra/helper';
import Service from "./../../extra/getAPI";
import MDDone from "./modal/success";
import MDFail from "./modal/fail";
import front from './../acsset/goc-chinh.png';
import back from './../acsset/phia-sau.png';
import left from './../acsset/ben-trai.png';
import right from './../acsset/ben-phai.png';
import frontLeft from './../acsset/goc-45-truoc-ben-trai.png';
import frontRight from './../acsset/goc-45-truoc-ben-phai.png';
import backLeft from './../acsset/goc-45-sau-ben-trai.png';
import backRight from './../acsset/goc-45-sau-ben-phai.png';
import leftHeadlight from './../acsset/den-pha-trai.png';
import rightHeadlight from './../acsset/den-pha-phai.png';
import windshield from './../acsset/kinh-chan-gio-truoc.png';
import speedometer from './../acsset/dong-ho-tap-lo.png';
import registrationCertificate from './../acsset/giay-dang-ky-xe.png';
import inspectionStamps from './../acsset/giay-kiem-dinh-xe.png';
import certificate from './../acsset/giay-chung-nhan.png';
import invoices from './../acsset/hoa-don.png';
import vin from './../acsset/so-khung-xe.png';
import damage from './../acsset/ton-that-xe.png';
import moment from "moment";
const { useBreakpoint } = Grid;
export const AuthContext = React.createContext();

const Index = (props) => {
  const [step, setStep] = useState(1);
  const [dataCheckupload, setDataCheckupload] = useState({});
  const [imageKeys, setImageKeys] = useState([]);
  const [loading, setLoading] = useState(false);
  const [carNameOrder, setCarNameOrder] = useState(null);
  const [messErrApi, setMessErrApi] = useState(null);

  const [open, setOpen] = useState({
    done: false,
    fail: false,
  });
  const isMobile = useBreakpoint().xs;

  const arrDefault = [
    {
      title: 'Góc chính diện xe',
      code: 'front',
      description: 'Xe chụp phải nằm chính giữa khung hình, bao gồm biển số xe và đảm bảo không bị mất góc hay bị che chắn',
      urlLocal: [],
      imgDefault: front,
      urlUpload: []
    },
    {
      title: 'Phía sau xe',
      code: 'back',
      description: 'Xe chụp phải nằm chính giữa khung hình, bao gồm biển số xe và đảm bảo không bị mất góc hay bị che chắn',
      urlLocal: [],
      imgDefault: back,
      urlUpload: []
    },
    {
      title: 'Bên trái xe',
      code: 'left',
      description: 'Xe chụp phải nằm chính giữa khung hình, bao gồm biển số xe và đảm bảo không bị mất góc hay bị che chắn',
      urlLocal: [],
      imgDefault: left,
      urlUpload: []
    },
    {
      title: 'Bên phải xe',
      code: 'right',
      description: 'Xe chụp phải nằm chính giữa khung hình, bao gồm biển số xe và đảm bảo không bị mất góc hay bị che chắn',
      urlLocal: [],
      imgDefault: right,
      urlUpload: []
    },
    {
      title: 'Góc 45° trước bên trái',
      code: 'frontLeft',
      description: 'Xe chụp phải nằm chính giữa khung hình, bao gồm biển số xe và đảm bảo không bị mất góc hay bị che chắn',
      urlLocal: [],
      imgDefault: frontLeft,
      urlUpload: []
    },
    {
      title: 'Góc 45° trước bên phải',
      code: 'frontRight',
      description: 'Xe chụp phải nằm chính giữa khung hình, bao gồm biển số xe và đảm bảo không bị mất góc hay bị che chắn',
      urlLocal: [],
      imgDefault: frontRight,
      urlUpload: []
    },
    {
      title: 'Góc 45° sau bên trái',
      code: 'backLeft',
      description: 'Xe chụp phải nằm chính giữa khung hình, bao gồm biển số xe và đảm bảo không bị mất góc hay bị che chắn',
      urlLocal: [],
      imgDefault: backLeft,
      urlUpload: []
    },
    {
      title: 'Góc 45° sau bên phải',
      code: 'backRight',
      description: 'Xe chụp phải nằm chính giữa khung hình, bao gồm biển số xe và đảm bảo không bị mất góc hay bị che chắn',
      urlLocal: [],
      imgDefault: backRight,
      urlUpload: []
    },
    {
      title: 'Đèn pha trái',
      code: 'leftHeadlight',
      description: 'Đứng góc nghiêng để chụp đủ góc độ đèn và hình chụp phải nằm chính giữa khung hình',
      urlLocal: [],
      imgDefault: leftHeadlight,
      urlUpload: []
    },
    {
      title: 'Đèn pha phải',
      code: 'rightHeadlight',
      description: 'Đứng góc nghiêng để chụp đủ góc độ đèn và hình chụp phải nằm chính giữa khung hình',
      urlLocal: [],
      imgDefault: rightHeadlight,
      urlUpload: []
    },
    {
      title: 'Kính chắn gió trước',
      code: 'windshield',
      description: 'Xe chụp phải nằm chính giữa khung hình, bao gồm biển số xe và đảm bảo không bị mất góc hay bị che chắn',
      urlLocal: [],
      imgDefault: windshield,
      urlUpload: []
    },
    {
      title: 'Chụp đồng hồ táp lô',
      code: 'speedometer',
      description: 'Nổ máy xe 30 giây mới chụp lại, có số km tổng và hình chụp phải nằm chính giữa khung hình',
      urlLocal: [],
      imgDefault: speedometer,
      urlUpload: []
    },
    {
      title: 'Giấy chứng nhận',
      code: 'certificate',
      description: 'Hình chụp phải nằm chính giữa khung hình, đảm bảo không bị mất góc hay bị che chắn',
      urlLocal: [],
      imgDefault: certificate,
      urlUpload: []
    },
    {
      title: 'Hoá đơn',
      code: 'invoices',
      description: 'Hình chụp phải nằm chính giữa khung hình, đảm bảo không bị mất góc hay bị che chắn',
      urlLocal: [],
      imgDefault: invoices,
      urlUpload: []
    },
    {
      title: 'Giấy đăng ký xe',
      code: 'registrationCertificate',
      description: 'Hình chụp phải nằm chính giữa khung hình, đảm bảo không bị mất góc hay bị che chắn',
      urlLocal: [],
      imgDefault: registrationCertificate,
      urlUpload: []
    },
    {
      title: 'Giấy đăng kiểm xe',
      code: 'inspectionStamps',
      description: 'Hình chụp phải nằm chính giữa khung hình, đảm bảo không bị mất góc hay bị che chắn',
      urlLocal: [],
      imgDefault: inspectionStamps,
      urlUpload: []
    },
    {
      title: 'Số khung xe',
      code: 'vin',
      description: 'Hình chụp phải nằm chính giữa khung hình, đảm bảo không bị mất góc hay bị che chắn',
      urlLocal: [],
      imgDefault: vin,
      urlUpload: []
    },
    {
      title: 'Tổn thất xe (nếu có)',
      code: 'damage',
      description: 'Hình chụp phải nằm chính giữa khung hình, đảm bảo không bị mất góc hay bị che chắn',
      imgDefault: damage,
      urlLocal: [],
      urlUpload: []
    },
  ]

  useEffect(() => {
    CheckUpload();
  }, []);

  const CheckUpload = async (e) => {
    const orderCode = Helper.getParamUrlByKey("orderCode");
    Service.apicall("GET", `api/v1/product/phy-damage-cov/${orderCode}/check-upload`)
      .then((res) => {
        const data = res.data
        if (data.statusCode === 200) {
          if (data?.result?.status === 1 || data?.result?.status === 4) {
            const merged = data?.result?.config?.imageKeys?.map(img => {
              const found = arrDefault.find(a => a.code === img.code);
              return { ...img, ...found, title: img.title };
            });
            setImageKeys(merged);
            setTimeout(() => {
              setDataCheckupload(data?.result);
              setStep(2);
            }, 1500);
            return;
          }
          setDataCheckupload(data?.result);
        }
      })
      .catch((err) => {
        message.error('Có lỗi xảy ra vui lòng kiểm tra!');
      });
  };

  const validateImages = (imageKeys) => {
    const invalidItems = imageKeys?.filter(
      (item) => item.required && (!item.urlLocal || item.urlLocal.length === 0)
    );
    if (invalidItems?.length > 0) {
      const missingTitles = invalidItems.map((i) => i.title).join(", ");
      message.error(<div>Vui lòng chụp đầy đủ hình bắt buộc: <b>{missingTitles}</b></div>);
      return false;
    }
    return true;
  };

  const uploadAllImages = async (imageKeys) => {
    const order = Helper.getParamUrlByKey("orderCode");
    if (!validateImages(imageKeys)) return;
    setLoading(true);
    try {
      const updatedList = imageKeys.map(item => ({
        ...item,
        urlUpload: item.urlLocal.map((data) => ({ captureAt: new Date(data?.lastModifiedDate || data?.lastModified).toLocaleString("vi-VN", { timeZone: "Asia/Ho_Chi_Minh" }) }))
      }));
      for (const item of updatedList) {
        if (!item.urlLocal?.length) continue;
        for (let i = 0; i < item.urlLocal.length; i++) {
          const localFile = item.urlLocal[i];
          const file = localFile instanceof File
            ? localFile
            : new File([await (await fetch(localFile)).blob()], `photo-${Date.now()}.jpg`, { type: "image/jpeg" });

          const form = new FormData();
          const random = (Math.random() + 1).toString(36).substring(7);
          const carName = carNameOrder || random;
          const storage = Helper.getParamUrlByKey("storage") || "s3";
          const timestamp = Date.now();
          form.append("storage", storage);
          form.append("file", file);
          form.append("path", `/user/vat-chat-oto/${order}/${timestamp}-${random}`);
          const res = await Service.apicall_upload_G2("POST", `upload`, form).catch(() => null);
          const url = res?.data?.link;
          if (url) {
            item.urlUpload[i].url = url
          } else {
            message.error("Có lỗi xảy ra khi upload!");
            return;
          };
        }
      }
      const listImg = updatedList.reduce((acc, { code, urlUpload }) => {
        if (urlUpload?.length) {
          acc[code] = urlUpload.map(({ url, captureAt }) => ({
            url,
            captureAt: moment(captureAt, "HH:mm:ss D/M/YYYY").format("YYYY-MM-DD HH:mm:ss"),
          }));
        }
        return acc;
      }, {});
      UploadPhoto(listImg);
    } catch (err) {
      setLoading(false);
      message.error("Có lỗi xảy ra khi upload!");
    } finally {
      setLoading(false);
    }
  };

  const UploadPhoto = (listImg) => {
    setLoading(true);
    const order = Helper.getParamUrlByKey("orderCode");
    const data = { images: listImg };
    // alert(listImg.invoices[0].captureAt);
    // return
    Service.apicall("POST", `api/v1/product/phy-damage-cov/${order}/upload-photo`, data)
      .then((res) => {
        setLoading(false);
        if (res?.data?.statusCode === 200) {
          setOpen({
            done: true,
            fail: false,
          })
        } else {
          setMessErrApi(res?.data?.message);
          setOpen({
            done: false,
            fail: true,
          })
        }
      })
      .catch((err) => {
        setLoading(false);
        handleCancel();
      });
  };

  const handleCancel = () => {
    setOpen({
      done: false,
      fail: false,
    })
  }

  const ActionList = (action, index, value) => {
    let listIsured = imageKeys;
    switch (action) {
      case "delete": {
        const { code, imgIndex } = value;
        listIsured = listIsured.map((item) => {
          if (item.code === code) {
            const newUrls = [...item.urlLocal];
            newUrls.splice(imgIndex, 1); //
            return { ...item, urlLocal: newUrls };
          }
          return item;
        });
        setImageKeys(listIsured);
        break;
      }

      case "edit": {
        listIsured[index] = { ...value };
        setImageKeys([...listIsured]);
        break;
      }

      default:
        break;
    }
  };

  const PageView = () => {
    switch (step) {
      case 1:
        return <Validate />;
      case 2:
        return <Capture />;
    }
  };

  return (
    <AuthContext.Provider
      value={{
        setStep, isMobile, dataCheckupload, imageKeys, ActionList,
        messErrApi
      }}
    >
      {
        open.done &&
        <MDDone handleCancel={handleCancel} />
      }
      {
        open.fail &&
        <MDFail uploadAllImages={() => uploadAllImages(imageKeys)} handleCancel={handleCancel} />
      }
      <div>
        <div style={{ height: isMobile ? 50 : 60 }}></div>
        <div style={{ background: '#fff', boxShadow: "0px 2px 4px 0px #0000001A", position: 'fixed', top: 0, width: '100%', zIndex: 1000 }}>
          <div style={{ padding: '0px 10px' }}>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%', height: isMobile ? 50 : 60, maxWidth: 834, margin: '0px auto' }}>
              <div style={{ fontWeight: 500, fontSize: isMobile ? 14 : 15 }}>
                Chụp hình xe ô tô
              </div>
              <img src={Logo} width={isMobile ? "47px" : "82px"} />
            </div>
          </div>
        </div>
        <div style={{ padding: isMobile ? "15px 15px" : '30px 50px' }}>
          {PageView()}
        </div>
        {
          step === 2 &&
          <>
            <div style={{ background: '#fff', boxShadow: '0px -2px 4px 0px #0000001A', position: 'fixed', bottom: 0, width: '100%', zIndex: 1000, borderRadius: isMobile ? '15px 15px 0px 0px' : '0px', }}>
              <div style={{ width: '100%', margin: '0px auto', padding: 15 }}>
                <Button
                  loading={loading}
                  onClick={() => uploadAllImages(imageKeys)}
                  style={{
                    backgroundColor: '#009B4B',
                    border: '1px solid #009B4B',
                    height: 44, width: isMobile ? '100%' : 834,
                    fontWeight: 500, boxShadow: 'none',
                    borderRadius: 8,
                    color: '#fff',
                    margin: '0px auto',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                  }}
                  type="primary"
                >
                  <div style={{ fontSize: 15 }}>Xác nhận</div>
                </Button>
              </div>
            </div>
            <div style={{ height: isMobile ? 75 : 75 }}></div>
          </>
        }
      </div>
    </AuthContext.Provider>
  );
};

export default Index;
